export default "__VITE_ASSET__wz0iy1ZF__"